import {useCallback, useRef} from 'react';
import {useAppSelector} from "./redux";
import {PREMIUM_USER_TYPE} from "../constants";

export function useUserPremium(){
    const user = useAppSelector(state => state.auth.user);

    return user?.group_id !== PREMIUM_USER_TYPE
}